import { useSelector } from "react-redux";
import "../Assets/scss/base.scss";
import { StoreProptypes } from "../PropTypes/StoreProptypes";
const iOS = require('is-ios')

interface PropTypes {
    children: any
}
// check if ios device
if(iOS){
    const body = document.querySelector("body");
    body?.classList.add("ios");
}

// component to render main template
const MainTemplate = (prop: PropTypes) => {

    const { children } = prop;

    const { isLoading } = useSelector((store: StoreProptypes) => store);
    
    return (
        <>
            <div className="page-main" aria-busy={isLoading ? "true" : "false"}>
                {children}
            </div>
        </>
    )
}

export default MainTemplate;